<template>
  <section
    :id="id || undefined"
    :class="[
      'ce-section relative overflow-hidden',
      compact ? 'py-12 sm:py-16 lg:py-20' : 'py-14 sm:py-20 lg:py-28',
      bg
    ]"
  >
    <div class="pointer-events-none absolute inset-0" aria-hidden="true">
      <div
        v-if="glow"
        class="section-glow absolute -right-24 -top-24 h-[28rem] w-[28rem] rounded-full blur-[110px]"
        :class="glow"
      ></div>

      <div
        v-if="connector"
        class="section-connector absolute left-1/2 top-0 h-12 w-px -translate-x-1/2"
      ></div>
    </div>

    <div
      :class="[
        'relative mx-auto px-5 sm:px-6 lg:px-8',
        wide ? 'max-w-[88rem]' : 'max-w-7xl'
      ]"
    >
      <header
        v-if="title || subtitle || kicker"
        :class="[
          'mb-9 sm:mb-12 lg:mb-14',
          align === 'left' ? 'max-w-4xl text-left' : 'mx-auto max-w-4xl text-center'
        ]"
        data-reveal
      >
        <p
          v-if="kicker"
          class="text-[11px] font-semibold uppercase tracking-[0.18em] text-violet-600 dark:text-violet-300"
        >
          {{ kicker }}
        </p>

        <h2
          v-if="title"
          class="mt-4 text-3xl font-semibold tracking-[-0.05em] text-[var(--ce-strong)] sm:text-5xl lg:text-6xl"
        >
          <slot name="title">
            {{ title }}
          </slot>
        </h2>

        <p
          v-if="subtitle"
          :class="[
            'mt-5 text-base leading-7 text-[var(--ce-muted)] sm:text-lg sm:leading-8',
            align === 'left' ? 'max-w-3xl' : 'mx-auto max-w-3xl'
          ]"
        >
          <slot name="subtitle">
            {{ subtitle }}
          </slot>
        </p>
      </header>

      <slot />
    </div>
  </section>
</template>

<script setup>
defineProps({
  id: { type: String, default: '' },
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  kicker: { type: String, default: '' },
  bg: { type: String, default: '' },
  glow: { type: String, default: '' },
  align: { type: String, default: 'center' },
  compact: { type: Boolean, default: false },
  wide: { type: Boolean, default: false },
  connector: { type: Boolean, default: false }
})
</script>

<style scoped>
.ce-section {
  color: var(--ce-text);
}

.section-glow {
  opacity: 0.85;
}

.section-connector {
  background:
    linear-gradient(
      to bottom,
      transparent,
      var(--ce-border),
      transparent
    );
}
</style>
